module.exports = __webpack_public_path__ + "img/34_44.07a49d45.png";